module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sidebar-menu', {
    attrs: {
      "width": "300px",
      "menu": _vm.menu,
      "collapsed": _vm.collapsed
    },
    on: {
      "toggle-collapse": _vm.onToggleCollapse,
      "item-click": _vm.onItemClick
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.collapsed) ? [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo img-fluid",
    attrs: {
      "src": _vm.logoUrlIcon,
      "alt": ""
    }
  })])] : [_c('div', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo img-fluid",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "login"
  }, [_vm._v("Bienvenido")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('b', [_vm._v(_vm._s(_vm.getUserName))])])])], 1)]], 2)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "toggle-icon"
    },
    slot: "toggle-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "slot": "dropdown-icon"
    },
    slot: "dropdown-icon"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "cambiar-contrasena"
    }
  }, [_c('cambiar-contra')], 1), _vm._v(" "), (_vm.isAdmin) ? _c('modal', {
    attrs: {
      "name": "registrar-usuario"
    }
  }, [_c(_vm.isAdmin ? 'RegistrarUsuario' : null, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('modal', {
    attrs: {
      "name": "actualizar-usuario"
    }
  }, [_c(_vm.isAdmin ? 'ActualizarUsuario' : null, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ayuda"
    }
  }, [_c('ayuda')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "changelog"
    }
  }, [_c('changelog')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('button', {
    ref: "changePassBtn",
    attrs: {
      "onclick": "$('#cambiar-contrasena-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
    ref: "registerUserBtn",
    attrs: {
      "onclick": "$('#registrar-usuario-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
    ref: "updateUserBtn",
    attrs: {
      "onclick": "$('#actualizar-usuario-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    ref: "helpBtn",
    attrs: {
      "onclick": "$('#ayuda-modal').modal('show');"
    },
    on: {
      "click": _vm.menuBtnClick
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d5230ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/persistant/Menu.vue
// module id = 1707
// module chunks = 6